import { z } from 'zod'

export const WORKOUT_COLORS = ['purple', 'green', 'blue', 'pink', 'peach'] as const
export const workoutAppearanceSchema = z.strictObject({
  title: z.string().trim().refine((value) => [...value].length >= 1 && [...value].length <= 40, '名称请填写1至40个字'),
  color: z.enum(WORKOUT_COLORS).optional(),
})
export const workoutOverrideSchema = workoutAppearanceSchema.extend({
  key: z.string().min(1).refine((value) => /^(shortcuts|healthKit):./u.test(value)),
})
export const workoutOverridesSchema = z.array(workoutOverrideSchema).refine(
  (records) => new Set(records.map(({ key }) => key)).size === records.length,
  '训练外观不能重复',
)
export type WorkoutAppearance = z.infer<typeof workoutAppearanceSchema>
export type WorkoutOverride = z.infer<typeof workoutOverrideSchema>
